var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeDown = function SvgVolumeDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 14v-4q0-.424.287-.713A.97.97 0 0 1 6 9h3l3.3-3.3q.476-.476 1.087-.213.613.263.613.938v11.15q0 .674-.613.938-.612.262-1.087-.213zm9.5-3q0 1.05-.475 1.988a4.46 4.46 0 0 1-1.25 1.537.49.49 0 0 1-.512.012A.46.46 0 0 1 16 15.1V8.85q0-.3.262-.438a.49.49 0 0 1 .513.013q.775.626 1.25 1.575.475.95.475 2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeDown);
export { ForwardRef as ReactComponent };